export enum eLocalStorageTags {
  OrderLastVisit = 'Order-Last-Visit',
  MostRecent = 'MostRecent',
  Pinned = 'Pinned',
  GlobalSearchBarSettings = 'GlobalSearchBarSettings',
  CustomView = 'CustomView',
}
